export default function isSortedAscending<Item>(list: Item[]) {
  if (list.length < 2) return true;

  let isSorted = true;
  for (let index = 1; index < list.length; index++) {
    if (list[index - 1] > list[index]) isSorted = false;
  }
  return isSorted;
}
